import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO, NAV } from "@/data/site";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${scrolled || open ? "bg-greige border-b border-darkgrey/30" : "bg-transparent"}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src={LOGO} alt="2e Lab" className="h-12 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-body text-sm tracking-wide">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.to.slice(1)}`}
              className={`link-underline hover-bold-noshift ${loc.pathname === n.to ? "text-ink" : "text-darkgrey"} hover:text-ink transition-colors`}>
              {n.label}
            </Link>
          ))}
        </nav>

        <button data-testid="mobile-menu-toggle" className="md:hidden text-ink" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-greige px-6 pb-8 pt-2 flex flex-col gap-5 font-body border-t border-darkgrey/20">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`mnav-${n.to.slice(1)}`} className="text-lg text-ink">{n.label}</Link>
          ))}
        </div>
      )}
    </header>
  );
};
